import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plan.campos.delete}
                postUrl={api.proyectos.config.plan.campos.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Campo del Plan de Trabajo ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Campo del Plan de Trabajo"}
                buttonTitle={"Eliminar Campo del Plan de Trabajo"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                buttonClass={"btn-danger"}
                closeButton={true}
                saveButtonLabel={"Eliminar"}
                danger={true}
                className={"ui-modal-dialog"}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Campo seleccionado</p>
                        <div className="ui-alert ui-alert-danger">
                            <i className="ti ti-trash" aria-hidden="true"></i>
                            <span>Esta acción eliminará el campo del plan de trabajo seleccionado.</span>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Campos/Delete.js